{
  "2xl": 1920,
  "lg": 992,
  "md": 768,
  "sm": 576,
  "xl": 1200
}
